module.exports = __webpack_public_path__ + "img/logo.34058c15.png";